import { render, staticRenderFns } from "./ManualBorrowDialog.vue?vue&type=template&id=fe85f360&scoped=true&"
import script from "./ManualBorrowDialog.vue?vue&type=script&lang=js&"
export * from "./ManualBorrowDialog.vue?vue&type=script&lang=js&"
import style0 from "./ManualBorrowDialog.vue?vue&type=style&index=0&id=fe85f360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe85f360",
  null
  
)

export default component.exports